import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";

export default function Hero() {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 6 },
      }}
    >
      <Grid container spacing={6} alignItems="center">
        {/* LEFT CONTENT */}
        <Grid item size={{ xs: 6, md: 6 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              lineHeight: 1.2,
              mb: 2,
            }}
          >
            Restaurant POS that works <br />
            the way your business works
          </Typography>

          <Box sx={{ mb: 2 }}>
            <TypeAnimation
              sequence={[
                "Simple",
                1000,
                "Fast",
                1000,
                "Reliable",
                1000,
                "Secure",
                1000,
              ]}
              speed={50}
              style={{
                fontSize: "2.5rem",
                fontWeight: 700,
                color: "#00ab55",
              }}
              repeat={Infinity}
            />
          </Box>

          <Typography
            sx={{
              color: "text.secondary",
              mb: 4,
              fontSize: "1.15rem",
              maxWidth: "90%",
            }}
          >
            Everything you need to run your restaurant — orders, tables, menus,
            billing & staff — all in one.
          </Typography>

          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              size="large"
              component={RouterLink}
              to="/pos/book-demo"
              sx={{ backgroundColor: "#f6521a" }}
            >
              Take a Free Demo
            </Button>
            <Button
              variant="outlined"
              size="large"
              to="/pos/explore-all-features"
              component={RouterLink}
            >
              Explore Features
            </Button>
          </Box>
        </Grid>

        {/* RIGHT IMAGE */}
        <Grid item size={{ xs: 6, md: 6 }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                borderRadius: 3,
                overflow: "hidden",
                boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
                width: "95%",
              }}
            >
              <img
                src="/img/home-banner.jpg"
                alt="POS screenshot"
                style={{ width: "100%", height: "auto", display: "block" }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
